module.exports = __webpack_public_path__ + "img/sold-out.ccbbc105.png";